(function () {
  const form = document.getElementById('CollectionControlsForm');
  const productsWrap = document.getElementById('CcProducts');
  if (!form || !productsWrap) return;

  // Restore view from storage
  const storedView = localStorage.getItem('cc_view');
  if (storedView === 'list' || storedView === 'grid') {
    productsWrap.setAttribute('data-view', storedView);
    syncViewButtons(storedView);
  }

  // Auto-submit for checkboxes and sort
  form.addEventListener('change', (e) => {
    const t = e.target;
    if (!t) return;

    // Don't auto-submit while typing price inputs (we use Apply button)
    if (t.matches('input[type="number"]')) return;

    // Submit on checkbox/select changes
    if (t.matches('input[type="checkbox"], select[name="sort_by"]')) {
      form.submit();
    }
  });

  // View toggle
  document.querySelectorAll('.cc-view__btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const view = btn.getAttribute('data-view');
      productsWrap.setAttribute('data-view', view);
      localStorage.setItem('cc_view', view);
      syncViewButtons(view);
    });
  });

  function syncViewButtons(view) {
    document.querySelectorAll('.cc-view__btn').forEach((b) => {
      const isActive = b.getAttribute('data-view') === view;
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  // Close dropdown when clicking outside
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.cc-filter[open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();
